<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from '../../../helpers';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;
        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar);
            let json = JSON.parse(decode(fetched.ind3));

            width.set(json.width);
            height.set(json.height);
            colorProfile = json.colorProfile;
            shtorType = json.shtorType;
            shtorColor = json.shtorColor;
            otkritie = json.otkritie;
            upakovka = json.upakovka;
            montaj = json.montaj;

            fetchData = await fetch();
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const color = options.color || {
        'Белый RAL 9016': 'Белый RAL 9016',
        'Кремовый RAL 1013': 'Кремовый RAL 1013',
        'Серый RAL 7040': 'Серый RAL 7040',
        'Коричневый RAL 8017': 'Коричневый RAL 8017',
        'Антрацит RAL 7016': 'Антрацит RAL 7016',
        'Черный RAL 9005': 'Черный RAL 9005',
        'Муар': 'Муар',
        'Алюминиевый натуральный': 'Алюминиевый натуральный',
    };

    // ─── Типы шторок и их ключевые слова (Штора Max) ────────────────────────
    const SHTORKA_TYPES = [
        { type: 'Полупрозрачная',         keyword: ['плиссированная шторка из полиэстера'] },
        { type: 'Dark out 90% затемнения', keyword: ['шторка darkout', 'darkout'] },
        { type: 'СОТЫ BLACKOUT ПРЕМИУМ',   keyword: ['шторка премиум сота'] },
        { type: 'СОТЫ КЛАССИК',            keyword: ['шторка классик сота'] },
        {type: 'СОТЫ полупрозрачные КЛАССИК', keyword: ['шторка полупрозрачная сота']},
    ];

    const UPAKOVKA_TYPES = [
        { keyword: 'картон' },
        { keyword: 'пупырчатая пленка' },
        { keyword: 'стрейч' },
    ];

    // ─── Динамические функции (как в Шторах плиссе) ─────────────────────────

    /** Все флаговые товары, содержащие keyword → уникальные ind2 */
    function colorsFromKeyword(keyword, result) {
        return [...new Set(
            result
                .filter(i => i.name.toLowerCase().includes(keyword) && i.flag === '1')
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )];
    }

    /** Доступные типы шторок — те, для которых в result есть хотя бы один товар */
    function availableShtorTypes(result) {
        if (!result) return [];
        const names = result.filter(i => i.flag === '1').map(i => i.name.toLowerCase());
        return SHTORKA_TYPES.filter(({ keyword }) =>
            keyword.some(kw => names.some(n => n.includes(kw)))
        );
    }

    /** Цвета шторки для выбранного типа */
    function shtorkaColors(type, result) {
        if (!result) return [];
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];
        return [...new Set(
            result
                .filter(i =>
                    entry.keyword.some(kw => i.name.toLowerCase().includes(kw)) &&
                    i.flag === '1'
                )
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )];
    }

    /** Доступная упаковка */
    function availableUpakovka(result) {
        return result
            .filter(i => UPAKOVKA_TYPES.some(u => i.name.toLowerCase().includes(u.keyword)))
            .map(i => i.name.trim());
    }

    // ─────────────────────────────────────────────────────────────────────────

    const fetch = async () => {
        let result = await network.fetch_data('Штора Max', '', '');
        let opts = await network.fetch_ind('Штора Max');
        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            colorProfile: _.groupBy(result, 'colorProfile'),
            shtorType: _.groupBy(result, 'shtorType'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options: opts,
            result,
        };
    };

    let
        width        = parameter('width', '240'),
        height       = parameter('height', '400'),
        colorProfile = 'Белый RAL 9016',
        shtorType    = 'Полупрозрачная',
        shtorColor   = '',          // будет задан после загрузки данных
        otkritie     = 'Сверху вниз',
        upakovka     = 'Картонный короб',
        montaj       = 'Нет',
        comment      = parameter('comment', ''),
        count        = parameter('count', 1)
    ;

    let fetchData = fetch();

    // После загрузки — установить начальный цвет шторки из данных
    fetchData.then(data => {
        const colors = shtorkaColors(shtorType, data.result);
        if (colors.length && !shtorColor) shtorColor = colors[0];

        const upakovki = availableUpakovka(data.result);
        if (upakovki.length && !upakovki.includes(upakovka)) upakovka = upakovki[0];

        change();
    });

    // ─── Расчёт стоимости ─────────────────────────────────────────────────────
    const change = _.debounce(async () => {
        let data = await fetchData;
        let quantity = +$count,
            w = +$width,
            h = +$height;

        let result = {
            type: 'штора-max',
            name: 'Штора Max',
            subname: [$width + 'x' + $height, ', ', colorProfile, ' - цвет профилей, ',
                shtorType, ', ', shtorColor, ' - шторка, ', otkritie, ', ',
                upakovka, ' - упаковка', montaj !== 'Нет' ? ', ' + montaj : ''].join(''),
            title: ['Штора Max', ' ', $width + 'x' + $height, ', ', colorProfile,
                ' - цвет профилей, ', shtorType, ', ', shtorColor, ' - шторка, ', otkritie, ', ',
                upakovka, ' - упаковка', montaj !== 'Нет' ? ', ' + montaj : ''].join(''),
            params: {
                ind1: [upakovka, ' - упаковка'].join(''),
                ind2: colorProfile,
                ind3: encode(JSON.stringify({
                    width: $width, height: $height,
                    colorProfile, shtorType, shtorColor,
                    otkritie, upakovka, montaj
                })),
                ind4: w,
                ind5: h,
            },
            price: { rozn: 0, opt: 0, sebest: 0 },
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 44
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();
            let kolvo = 0;

            if (name.includes('рама') && name.includes(colorProfile.toLowerCase())) {
                kolvo = (((w + 32) * 2 + (h + 32) * 2) / 1000).toFixed(3);
            }
            if (name.includes('створка') && name.includes(colorProfile.toLowerCase())) {
                kolvo = ((w + 32 - 65) * (otkritie === 'Сверху вниз' ? 1 : 2) / 1000).toFixed(3);
            }
            if (name.includes('пвх планка')) {
                kolvo = ((w + 32 - 65) * 2 / 1000).toFixed(3);
            }
            if (name.includes('защитная пвх вставка')) {
                kolvo = ((w + 32 - 65) * (otkritie === 'Сверху вниз' ? 1 : 2) / 1000).toFixed(3);
            }
            if (name.includes('двойной скотч')) {
                kolvo = ((w * 2 + h * 2) / 1000).toFixed(3);
            }

            // ── Шторка — через SHTORKA_TYPES ──────────────────────────────────
            const entry = SHTORKA_TYPES.find(t => t.type === shtorType);
            if (entry) {
                const matchesType = entry.keyword.some(kw => name.includes(kw));
                if (matchesType && item.ind2.trim() === shtorColor) {
                    if (shtorType === 'Полупрозрачная') {
                        kolvo = ((w - 2) * h / 2.2 * 0.028 / 10000).toFixed(3);
                    } else if (shtorType === 'Dark out 90% затемнения') {
                        kolvo = ((w / 1000) * h / 7.7 * 10 / 1000).toFixed(3);
                    } else {
                        kolvo = (((w + 9) / 1000) * ((h + 8) / 1000)).toFixed(3);
                    }
                }
            }

            // ── Нить ──────────────────────────────────────────────────────────
            if (name.includes('нить')) {
                const isSota = shtorType.toLowerCase().includes('соты');
                if (isSota && item.ind2.trim().toLowerCase() === 'белый') {
                    kolvo = ((w * 2 * (otkritie === 'Сверху вниз' ? 1 : 2) + h * 2 + 300) * 2 / 1000).toFixed(3);
                } else if (!isSota && item.ind2.trim() === shtorColor) {
                    kolvo = ((w * 2 * (otkritie === 'Сверху вниз' ? 1 : 2) + h * 2 + 300) * 2 / 1000).toFixed(3);
                }
            }

            if (name.includes('комплект фурнитуры'))      kolvo = (1 * (otkritie === 'Сверху вниз' ? 1 : 2)).toFixed(3);



            if (name.includes('металл угол внутренний'))   kolvo = (4).toFixed(3);
            if (name.includes('закл'))                     kolvo = (4).toFixed(3);
            if (name.includes(upakovka.toLowerCase()))     kolvo = 1;
            if (name.includes('работа'))                   kolvo = 1;

            if (kolvo) {
                const price = {
                    rozn:   fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price),
                    opt:    fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price),
                    sebest: fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost),
                };
                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn:   (+item.price).toFixed(2),
                        opt:    (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn   = _.sumBy(_.values(_.mapValues(result.materials, o => o.price)), 'rozn').toFixed(2);
        result.price.opt    = _.sumBy(_.values(_.mapValues(result.materials, o => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, o => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="parent">

            <div class="imgSystem justify-content-center align-content-center">
                <img style="max-height: 300px;" class="img-fluid p-3" src="/img/max/{otkritie === 'Двойное' ? 'max2' : 'max1'}.jpg"
                     alt="Шторы Max"/>
            </div>

            {#if ($width > (options.recomend?.width ?? 6000) || $height > (options.recomend?.height ?? 6000))}
                <div class="info">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase">
                        Изделие с данным размером не подлежит гарантии
                    </span>
                </div>
            {/if}

            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Шир., мм ≥ {options.recomend?.width ?? 6000}</label>
                        <input type="number"
                               class="form-control text-center {$width > (options.recomend?.width ?? 6000) ? 'text-danger' : ''}"
                               step="10" min="200" max="{options.max?.width ?? 6000}"
                               bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Выс., мм ≥ {options.recomend?.height ?? 3000}</label>
                        <input type="number"
                               class="form-control text-center {$height > (options.recomend?.height ?? 3000) ? 'text-danger' : ''}"
                               step="10" min="200" max="{options.max?.height ?? 3000}"
                               bind:value={$height} use:validate_int={$height}>
                    </div>
                </div>
            </div>
            <div class="otkritie">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Открывание</label>
                        <select class="form-control form-select" bind:value={otkritie}>
                                <option value="Сверху вниз">Сверху вниз</option>
                                <option value="Двойное">Двойное</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="colorProfile">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет профиля</label>
                        <select class="form-control form-select" bind:value={colorProfile}>
                            {#each Object.entries(color) as [value]}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <!-- Вид шторы — список теперь из data.result, как в плиссе -->
            <div class="shtorType">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Вид шторы</label>
                        <select class="form-control form-select" bind:value={shtorType}
                                on:change={() => shtorColor = shtorkaColors(shtorType, data.result)[0]}>
                            {#each availableShtorTypes(data.result) as { type }}
                                <option value="{type}">{type}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <!-- Цвет шторы — список теперь из data.result -->
            <div class="shtorColor">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет шторы</label>
                        <select class="form-control form-select" bind:value={shtorColor}>
                            {#each shtorkaColors(shtorType, data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <!-- Упаковка — список теперь из data.result -->
            <div class="upakovka">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Упаковка</label>
                        <select class="form-control form-select" bind:value={upakovka}>
                            {#each availableUpakovka(data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

           <!-- <div class="montaj d-none">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Для монтажа</label>
                        <select class="form-control form-select" bind:value={montaj}>
                            {#each montaji as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>-->

            <div class="quantity">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1"
                               bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Примечание</label>
                        <textarea class="form-control" bind:value={$comment}></textarea>
                    </div>
                </div>
            </div>

            <div class="ralcolor">
                <RalColor color={colorProfile} bind:comment={$comment}/>
            </div>

        </div>
    </div>
{/await}

<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
            "info          info"
            "width         height"
            "otkritie otkritie"
            "colorProfile  colorProfile"
            "shtorType     shtorColor"
            "upakovka      montaj"
            "quantity      quantity"
            "ralcolor      ralcolor"
            "comment       comment"
            "imgSystem     imgSystem"
    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                "imgSystem  info          info"
                "imgSystem  width         height"
                "imgSystem  otkritie otkritie"
                "imgSystem  colorProfile  colorProfile"
                "imgSystem  shtorType     shtorColor"
                "imgSystem  upakovka      montaj"
                "quantity   quantity      quantity"
                "ralcolor   ralcolor      ralcolor"
                "comment    comment       comment"


        }
    }

    .imgSystem {
        grid-area: imgSystem;
    }

    .info {
        grid-area: info;
    }

    .width {
        grid-area: width;
    }

    .height {
        grid-area: height;
    }

    .colorProfile {
        grid-area: colorProfile;
    }

    .shtorType {
        grid-area: shtorType;
    }

    .shtorColor {
        grid-area: shtorColor;
    }


    .upakovka {
        grid-area: upakovka;
    }

    .montaj {
        grid-area: montaj;
    }

    .quantity {
        grid-area: quantity;
    }

    .comment {
        grid-area: comment;
    }

    .ralcolor {
        grid-area: ralcolor;
    }
    .otkritie {
        grid-area: otkritie;
    }
</style>


